import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { OnboardingPage } from '@pages';
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { LoadingProvider } from '@providers/loading/loading';
import { TranslateService } from '@ngx-translate/core';
import { VERSION } from '@env';
import { StatusBar } from '@ionic-native/status-bar';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

  jugador: Jugador = new Jugador;
  jugadorGuardar: Jugador = new Jugador;
  equipo: Equipo;
  isLogin: boolean = true;
  isLoginClass: boolean = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private loadingProvider: LoadingProvider,
    private translateService: TranslateService,
    private authProvider: AuthProvider,
    private statusBar: StatusBar,
  ) {
  }

  ionViewDidLoad() {
    this.statusBar.backgroundColorByHexString('#461850');
  }

  async login() {
    try {
      this.loadingProvider.show(true);

      let e = await  this.authProvider.login({
        correo: this.jugador.correo,
        contrasenia: this.jugador.contrasenia,
        versionApp: VERSION
      });
      this.jugadorGuardar = e.perfil;
      this.equipo = e.equipo;

      this.authProvider.saveSession(this.jugadorGuardar);
      this.authProvider.saveEquipo(this.equipo);
      this.authProvider.saveToken(e.token);
      let avatar = await this.authProvider.downloadAvatar(this.jugadorGuardar._id);

      this.authProvider.saveAvatar(avatar);
      this.navCtrl.setRoot(OnboardingPage);

      this.statusBar.backgroundColorByHexString('#8C41D4');
    } catch (e) {
      this.showAlert(this.translateService.instant('login.notuser'))
    } finally {
      this.loadingProvider.show(false);
    }

  }

  toggleForm() {
    this.isLoginClass = !this.isLoginClass;
    setTimeout( () => {
      this.isLogin = !this.isLogin;
    }, 400)
  }

  recuperarContrasenia() {
    if(!this.jugador.correo) {
      this.showAlert(this.translateService.instant('login.notemail'))
      return false;
    }

    this.loadingProvider.show(true);
    this.authProvider.recuperarContrasenia(this.jugador.correo)
      .then( response => {

        this.toggleForm();
        this.loadingProvider.show(false);
        const alert = this.alertCtrl.create({
            title: '',
            subTitle: this.translateService.instant('login.sendedEmail'),
            buttons: ['OK']
          });
          alert.present();

        })
        .catch( e => {
          this.loadingProvider.show(false);
          const error = e.error.message || this.translateService.instant('login.sendedEmailNotFound');
          alert(error);
        });
  }

  showAlert(message: string) {
   const alert = this.alertCtrl.create({
     title: '¡Error!',
     subTitle: message,
     buttons: ['OK']
   });
   alert.present();
 }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts